module.exports = global["jQuery"] = require("-!/Users/fuji/Sites/fooandfoo/shopify-theme/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// /Users/fuji/Sites/fooandfoo/shopify-theme/~/expose-loader?jQuery!/Users/fuji/Sites/fooandfoo/shopify-theme/~/jquery/dist/jquery.js
// module id = 3
// module chunks = 0